import {UserModelV2} from '@albert-io/models';

// This map is necessary because SchoolV5 uses abbreviations (e.g. AZ) while StandardSetCreatorsV1 uses the full state name
export const stateMap = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

export function getUserStateName(user: UserModelV2) {
  if (!user.getStandardSetCreators().isEmpty()) {
    // assumption is that user can only select ONE standard set creator with type === 'state'
    const userStateSetting = user
      .getStandardSetCreators()
      .find((creator) => creator.type === 'state');
    if (userStateSetting) {
      return userStateSetting.getName();
    }
  }
  // if there are no state preferences, the user is onboarding and we try to get the state from their school relationship
  if (!user.getSchool().isEmpty()) {
    const stateAbbr = user.getSchool().getState();
    if (stateAbbr) {
      return stateMap[stateAbbr];
    }
  }

  return null;
}

export function isUserFromUSA(user: UserModelV2) {
  if (user.getSchool().isEmpty()) {
    // assume if school relationship is not included that the uesr IS from the USA
    return true;
  }
  return user.getSchool().getCountry() === 'United States of America';
}
